export const MENU = {
  veg: {
    title: "Veg Sliders",
    items: [
      { name: "Paneer Cheese Pull", price: 139 },
      { name: "Chilli Paneer", price: 149 },
      { name: "Piri Piri Paneer", price: 155 },
      { name: "Cheesy Pav Bhaji", price: 158 },
      { name: "Paneer Tikka", price: 180 },
      { name: "Cheesy Corn & Palak", price: 165 },
      { name: "Tomato & Cheese", price: 144 },
      { name: "Paneer Makhni", price: 199 },
      { name: "Italian Cheese Melt", price: 185 },
      { name: "Korean Kimchi", price: 155 },
    ],
  },
  nonVeg: {
    title: "Non-Veg Sliders",
    items: [
      { name: "Cheesy Chicken", price: 220 },
      { name: "Cheesy Egg", price: 210 },
      { name: "Butter Chicken", price: 230 },
      { name: "Cheesy Chicken Tikka", price: 255 },
      { name: "Chicken Keema", price: 250 },
      { name: "Mutton Keema", price: 280 },
    ],
  },
  sides: {
    title: "Sides",
    items: [
      { name: "Fries (Salted / Piri Piri) — Small", price: 99 },
      { name: "Fries (Salted / Piri Piri) — Medium", price: 135 },
      { name: "Fries (Salted / Piri Piri) — Large", price: 169 },
      { name: "Baked Cheesy Nachos — Small", price: 110 },
      { name: "Baked Cheesy Nachos — Medium", price: 160 },
      { name: "Baked Cheesy Nachos — Large", price: 190 },
    ],
  },
  dessert: {
    title: "Dessert",
    items: [
      { name: "Brownie with Hot Chocolate Sauce", price: 260 },
      { name: "Brownie with Ice Cream", price: 280 },
    ],
  },
  drinks: {
    title: "Drinks",
    items: [
      { name: "OG Cold Coffee", price: 120 },
      { name: "Cold Coffee with Ice Cream", price: 150 },
      { name: "Vietnamese Cold Coffee", price: 155 },
      { name: "Vanilla Cold Brew", price: 140 },
      { name: "Fizzy Cranberry Brew", price: 175 },
    ],
    note: "Cold drinks available on MRP",
  },
};

export const ALL_ITEMS = Object.values(MENU).flatMap((s) => s.items);

export const IMAGES = {
  hero: "/assets/italian-cheese-melt.png",
  veg: "/assets/cheese-pull-tray.png",
  chicken: "/assets/chicken-cheese-melt.png",
  party: "/assets/party-collage.png",
  fries: "https://images.unsplash.com/photo-1598679253544-2c97992403ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  nachos: "https://images.unsplash.com/photo-1761315412554-ca6156afee65?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  dessert: "https://images.unsplash.com/photo-1654796605330-8a1248a2cb07?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  drinks: "https://images.unsplash.com/photo-1562447457-579fc34967fb?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
};

export const CONTACT = {
  whatsapp: "919818696211",
  whatsappDisplay: "+91 98186 96211",
  phone: "+91 99585 74744",
};
